<!-- 审核账户信息 -->
<script setup>
import { ref, onMounted, watch } from 'vue';
// import companyImg from "@/assets/images/account/company.png"
import i18n from "@/i18n"
import { getBusinessInfoDetail, getFileUrl, database_template_name_v3, uploadFile, permission_tree_v3, get_permission_user_v3, update_userInfo, set_permission_user_v3, company_type_list } from "@/service/index"
import { useRoute, useRouter } from 'vue-router';
import { showMessage } from "@/utils/hooks/message"
import PreviewImg from "@/components/common/PreviewImg";
import countryListData from '@/utils/country.js';
import CountryFlag from 'vue-country-flag-next'
import fileActionCom from "@/components/common/fileAction.vue";
import { dateFormat1 } from "@/utils/common.js";
import { AreaJson } from "@/utils/china.js"
import { getLangValue,getLangValueByKey, makeQrCode, switch_company_type_list_to_language_config } from "@/utils/common"; //获取后端语言
// import flatPickr from "vue-flatpickr-component";
const accept = '.png,.jpeg,.jpg,.pdf'
const countryList = ref(countryListData);
const countryList1 = ref(countryListData);
const currendData = ref({})
const isCheckForm = ref(false)
const formData = ref({
    company_name: '',
    company_type: '',
    contact_first_name: '',
    contact_last_name: '',
    contact_email: '',
    landline_number: '',
    business_scope: [],
    logo: [],
    qualification_documents: [],
    company_qualification_validity_period: '',
    company_qualification_certification_body: '',
    company_website: '',
})
const cityList = ref([])
const cityList1 = ref([])
const oldCityList = ref([])
const oldCityList1 = ref([])
const provinceList = ref([])
const provinceList1 = ref([])
const main_business_areas_list = ref([])
const route = useRoute()
const router = useRouter()
const current_tab = ref(0)
const current_tab1 = ref(0)
const companyAddressList = ref([])
const contact_address = ref([]) // 新增信息
const showPreviewImg = ref(false)
const showPreviewImg1 = ref(false)
const qrcodeImgUrl = ref('')
const srcList = ref([])
const srcList1 = ref([])
const treeRef = ref(null)
const permission_tree = ref([])
const companyTypeList = ref([]) // 新增企业类型
const shortcuts = [
    {
        text: getLangValue("base.permanent"),
        value: `9999-12-31`,
    },
];
const tabList = ref([
    getLangValue("my.account", "progressInfo1"),
    getLangValue("business-user", "detail_tab1"),
    getLangValue("business-user", "detail_tab2"),
])
const tabList1 = [
    {
        id: 0,
        name: getLangValue('business-user', "functionalpermissions"),
        icon: 'ri-group-fill'
    }
]
//账户信息
const accountInfo = [
    {
        name: getLangValue('my.account', "form_companyName"),
        key: 'company_name',
        type: 'text',
    },
    {
        name: getLangValue('my.account', "form_Enterprisetype"),
        key: 'company_type',
        type: 'company_type',
    },
    {
        name: getLangValue('my.account', "form_contacts"),
        key: 'contact_first_name,contact_last_name',
        type: 'contact',
    },
    {
        name: getLangValue('my.account', "form_email"),
        key: 'contact_email',
        type: 'text',
    },
    {
        name: getLangValue('my.account', "form_phone"),
        key: 'landline_number',
        type: 'landline_number',
    },
    {
        name: getLangValue('my.account', "form_phone_number"),
        key: 'mobile_phone_number',
        type: 'mobile_phone_number',
    },
    {
        name: getLangValue('my.account', "form_main_business_areas"),
        key: 'business_scope',
        type: 'business_scope',
    },
    // {
    //     name: getLangValue('business-user', "examine3"),
    //     key: 'examine_info',
    // }
]
// 企业信息
const companyInfo = [
    {
        name: getLangValue('my.account', "form_Enterprise_registered_address"),
        key: 'place_of_incorporation',
        type: 'place_of_incorporation',
    },
    {
        name: getLangValue('my.account', "form_Certificate_No"),
        key: 'certificate_number',
        type: 'text',
    },
    {
        name: getLangValue('my.account', "form_qualification_certification"),
        key: 'company_qualification_validity_period',
        type: 'text',
    },
    {
        name: getLangValue('my.account', "form_qualification_certification1"),
        key: 'company_qualification_certification_body',
        type: 'text',
    },
    {
        name: getLangValue('my.account', "form_company_link"),
        key: 'company_website',
        type: 'text',
    },
    {
        name: getLangValue('my.account', "form_qualification_documents"),
        key: 'file',
        index: 0,
    },
    {
        name: getLangValue('my.account', "logo"),
        key: 'file',
        index: 1
    }
]
// 生产地址信息
const productAddress = [
    {
        name: getLangValue('my.account', 'form_country'),
        key: 'country',
        type: 'country',
    },
    {
        name: getLangValue('my.account', 'form_province'),
        key: 'province',
        type: 'text',
    },
    {
        name: getLangValue('my.account', 'form_province_code'),
        key: 'province_code',
        type: 'text',
    },
    {
        name: getLangValue('my.account', 'form_City'),
        key: 'city',
        type: 'text',
    },
    {
        name: getLangValue('my.account', 'form_address'),
        key: 'address',
        type: 'text',
    },
    {
        name: getLangValue('my.account', 'form_post'),
        key: 'postcode',
        type: 'text',
    }
];
// 联系人地址信息
const contactAddress = [
    {
        name: getLangValue('my.account', 'form_country'),
        key: 'country',
        type: 'country',
    },
    {
        name: getLangValue('my.account', 'form_province'),
        key: 'province',
        type: 'text',
    },
    {
        name: getLangValue('my.account', 'form_City'),
        key: 'city',
        type: 'text',
    },
    {
        name: getLangValue('my.account', 'form_address'),
        key: 'address',
        type: 'text',
    },
    {
        name: getLangValue('my.account', 'form_post'),
        key: 'postcode',
        type: 'text',
    }
];
const PageHeaderT = getLangValue('business-user', "title")
const PageHeaderItems = [
    {
        text: getLangValue('business-user', "title"),
        active: false,
        href: `/business_information_management?search_type=${route.query.search_type || 0}`
    },
    {
        text: getLangValue('business-user', "subtitle2"),
        active: true,
    },
]
const getTemplateList = async () => {
    // let data = sessionStorage.getItem('t_menuList') ? JSON.parse(sessionStorage.getItem('t_menuList')) : []
    // if (data.length > 0) {
    //     main_business_areas_list.value = data;
    // } else {
    const reps = await database_template_name_v3({ status: 1 })
    if (reps) {
        if (reps.payload.length == 0) {
            main_business_areas_list.value = [{ name: getLangValueByKey('base.none'), name_en: getLangValueByKey('base.none', 'en'), role_key: '无', }]
        } else {
            main_business_areas_list.value = reps.payload;
        }
    }
    // }
}

const viewFile = (type) => {
    /**展示附件信息 */
    // activeImageSrc.value = 'http://localhost:8080/static/img/company.29dfa381.png';
    // if (activeImageSrc.value == "") {
    //     return;
    // }
    if (type == 0) {
        if (srcList.value.length == 0) {
            showMessage('info', getLangValue('base.no_pictures'))
            return
        }
        // 需要判断是图片还是附件
        const type = setType(srcList.value[0].name)
        if (type == 'image') {
            showPreviewImg.value = true;
        } else {
            window.open(srcList.value[0].url, '_blank')
        }
    } else {
        if (srcList1.value.length == 0) {
            showMessage('info', getLangValue('base.no_pictures'))
            return
        }
        showPreviewImg1.value = true;
    }
}
const handlerToggleTab = (i) => {
    current_tab.value = i
    if (i == 2 && permission_tree.value.length == 0) {
        get_permission_tree_v3();
    }
}
const handlerToggleTab1 = (i) => {
    current_tab1.value = i
}
const setType = (filename) => {
    // 获取文件类型
    let fileType = filename.split('.').pop()
    if (fileType == 'jpg' || fileType == 'jpeg' || fileType == 'png' || fileType == 'gif') {
        return 'image'
    } else if (fileType == 'dwg' || fileType == 'dwt' || fileType == 'dxf' || fileType == 'dwf') {
        return 'cad'
    }
    return 'file'
}
const getImage = async () => {
    // 获取图片
    let arr = currendData.value.company_logo ? [...currendData.value.company_qualification, ...[currendData.value.company_logo]] : [...currendData.value.company_qualification]
    let imgIdStr = arr.join(',')
    if (imgIdStr) {
        getFileUrl({ attachments: imgIdStr }).then(resp => {
            if (resp) {
                //设置图片1
                let arr_qualification_documents = resp.payload.filter(item => currendData.value.company_qualification.includes(item.id))
                arr_qualification_documents.forEach(item => {
                    item.type = setType(item.name)
                })
                // console.log(arr_qualification_documents);
                if (currendData.value.company_qualification.length) {
                    srcList.value = arr_qualification_documents
                    formData.value.qualification_documents = arr_qualification_documents
                } else {
                    formData.value.qualification_documents = []
                }

                if (currendData.value.company_logo) {
                    //设置图片2
                    let arr_logo = resp.payload.filter(item => currendData.value.company_logo.includes(item.id))
                    srcList1.value = arr_logo
                    formData.value.logo = arr_logo
                } else {
                    formData.value.logo = []
                }
            }
        })
    } else {
        formData.value.logo = []
        formData.value.qualification_documents = []
        // console.log(formData.value.qualification_documents);
    }

}
const getDetailByid = async () => {
    let xx = true
    if (xx) {
        const resp = await getBusinessInfoDetail(route.query.id);
        if (resp) {
            currendData.value = resp.payload
            // currendData.value.company_logo= ''
            // let imgIdStr = currendData.value.company_qualification.join(',')
            // if (imgIdStr)
            //     getFileUrl({ attachments: imgIdStr }).then(resp => {
            //         if (resp) {
            //             srcList.value = resp.payload
            //             formData.value.qualification_documents = resp.payload
            //         }
            //     })
            // let imgIdStr1 = currendData.value.company_logo
            // if (imgIdStr1)
            //     getFileUrl({ attachments: imgIdStr1 }).then(resp => {
            //         if (resp) {
            //             srcList1.value = resp.payload
            //             formData.value.logo = resp.payload
            //         }
            //     })
            // 设置表单数据
            if (route.query.type == 'edit') {
                formData.value = { ...currendData.value }
                formData.value.business_scope = currendData.value.business_scope ? currendData.value.business_scope : []
                formData.value.Enterprise_registered_countryKey = getCountrykey(currendData.value.place_of_incorporation)
            }
            formData.value.company_type = currendData.value.company_type ? currendData.value.company_type.split(',') : []

            getImage();
            // 二维码
            makeCode();

            // 获取描述信息
            if (currendData.value.review_log && currendData.value.review_log.length) {
                let obj = currendData.value.review_log.pop()
                currendData.value.examine_info = obj.description ? obj.description : ''
            }
        }
    } else {
        currendData.value = {
            "company_name": "金科组数",
            "company_type": "生产商",
            "contact_first_name": "feng",
            "contact_last_name": "tao",
            "contact_email": "11107949255@qq.com",
            "landline_number": "2659866",
            "mobile_phone_number": "15108343658",
            "third_party_certification_company": true,
            "business_scope": "服装数据库,纱线数据库",
            "place_of_incorporation": "中国",
            "certificate_number": "dwq131",
            "company_qualification": [
                "66988197b9fc9a463208f059",
                "6699cb1c571be011cb92bbb0"
            ],
            "logo": [
                "6699cb1c571be011cb92bbb0"
            ],
            "Enterprise_registered_country": "阿富汗",
            "phoneCountry": "阿富汗",
            "phone_numberCountry": "安哥拉",
            registre_time: 'dwqdwqdq',
            lastLoginTime: 'dwqdwq',
            "company_address": [
                {
                    "name": "AF",
                    "country": "阿富汗",
                    "province": "11",
                    "city": "11",
                    "address1": "1",
                    "address2": "",
                    "address3": "",
                    "postcode": "1"
                },
                {
                    "name": "AF",
                    "country": "阿富汗",
                    "province": "1",
                    "city": "11",
                    "address1": "1",
                    "address2": "",
                    "address3": "",
                    "postcode": "1"
                }
            ],
            examine_info: '我们未在您提交的企业信息中核实您的身份，同时您所提交的信息不能够证明您在行业中的角色，我们可以为您提供登录的服务，但是会限制您所浏览的内容，如需获取这些权限，请您提供完整的企业信息！',
            examine_info1: '我们未在您提交的企业信息中核实您的身份，同时您所提交的信息不能够证明您在行业中的角色，我们可以为您提供登录的服务，但是会限制您所浏览的内容，如需获取这些权限，请您提供完整的企业信息！',
        }
    }

}

const makeCode = async () => {
    // 生产二维码
    if (currendData.value.place_of_incorporation && currendData.value.certificate_number) {
        const reps = await makeQrCode({ type: 1, id: route.query.id })
        if (reps) {
            qrcodeImgUrl.value = reps
        }
    }
}

// const viewFile = () => {
//     /**展示附件信息 */
//     showPreviewImg.value = true;
// }
const back = () => {
    window.close();
    // router.push({ path: '/business_information_management', query: { search_type: route.query.search_type || 0 } });
}

const checkForm = () => {
    /**表单验证 */
    isCheckForm.value = true;
    let checkRes = true;
    for (const item in accountInfo) {
        const { key } = accountInfo[item]
        if (key == 'business_scope' || key == 'company_type') {
            if (formData.value[key].length == 0 || formData.value[key] == null) {
                checkRes = false
                break;
            }

        } else if (key == 'contact_first_name,contact_last_name') {
            if (!formData.value['contact_first_name'] || !formData.value['contact_last_name']) {
                checkRes = false
                break;
            }
        } else {
            if (!formData.value[key]) {
                checkRes = false
                break;
            }
        }

    }
    return checkRes;
}
const checkEmail = () => {
    if (formData.value.contact_email) {
        // 邮箱格式
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!regex.test(formData.value.contact_email)) {
            return false;
        }
    }
    return true;
}

const filterCountry = (query) => {
    // 搜索国家
    if (query) {
        countryList.value = countryList1.value.filter((item) => {
            if ((item.zh.toLowerCase()).includes(query.toLowerCase()) ||  (item.en.toLowerCase()).includes(query.toLowerCase())) {
                return true
            }
        })
    } else {
        countryList.value = [...countryList1.value] //val为空时，还原数组
    }
}
const filterProvince = (query, key) => {
    // 搜索省份  自带的搜索不管用  
    // console.log(query);
    if (query) {
        provinceList.value[key] = AreaJson.filter((item) => {
            if (item.name.includes(query)) {
                return true
            }
        })
    } else {
        provinceList.value[key] = [...AreaJson] //val为空时，还原数组
    }
}

const filterCity = (query, key) => {
    // 搜索省份  自带的搜索不管用 
    // console.log(query);
    if (query) {
        cityList.value[key] = oldCityList.value[key].filter((item) => {
            if (item.name.includes(query)) {
                return true
            }
        })
    } else {
        cityList.value[key] = [...oldCityList.value[key]] //val为空时，还原数组
    }
}

const changeAddressCountry = () => {
    formData.value.Enterprise_registered_countryKey = getCountrykey(formData.value.place_of_incorporation)
}

const getCountrykey = (country) => {
    if (country) {
        let arr = countryList.value.filter(item => item.zh === country || item.en === country)
        if (arr.length > 0) {
            return arr[0].key
        }
    }
    return ''
}
const changeCountry = (key) => {
    // 选择国家 展示对应的key
    if (!companyAddressList.value[key].country) {
        companyAddressList.value[key].countryKey = ''
    } else {
        let arr = countryList.value.filter(item => item.zh === companyAddressList.value[key].country || item.en === companyAddressList.value[key].country)
        if (arr.length > 0) {
            companyAddressList.value[key].countryKey = arr[0].key
        }
    }
    // 如果是中国
    if (companyAddressList.value[key].countryKey == 'CN') {
        provinceList.value[key] = [...AreaJson]
    }
}

const changeCountry1 = (key) => {
    // 选择国家 展示对应的key
    if (!contact_address.value[key].country) {
        contact_address.value[key].countryKey = ''
    } else {
        let arr = countryList.value.filter(item => item.zh === contact_address.value[key].country || item.en === contact_address.value[key].country)
        if (arr.length > 0) {
            contact_address.value[key].countryKey = arr[0].key
        }
    }
    // 如果是中国
    if (contact_address.value[key].countryKey == 'CN') {
        provinceList1.value[key] = [...AreaJson]
    }
}


const checkFrom1 = () => {
    /**表单验证 */
    isCheckForm.value = true;
    let checkRes = true;
    // console.log(formData.value);
    for (const item in companyInfo) {
        const { key } = companyInfo[item]
        if (key == 'file') {
            if (formData.value['qualification_documents'].length == 0 || formData.value['qualification_documents'] == null) {
                checkRes = false
                break;
            }
            // if (formData.value['logo'].length == 0 || formData.value['logo'] == null) {
            //     checkRes = false
            //     break;
            // }
            // console.log(companyInfo[item]);
        } else if (key == 'company_qualification_validity_period' || key == 'company_qualification_certification_body') {
            if (formData.value.company_type.includes('7')) {
                if (!formData.value[key]) {
                    checkRes = false
                    break;
                }
            }
        } else {
            if (key != 'company_website' && !formData.value[key]) {
                checkRes = false
                break;
            }
        }

    }
    return checkRes
}
const checkProductionAddress = () => {
    // 验证企业生产地址是否完整
    let checkRes = true
    if (formData.value.company_type.includes('1') || formData.value.company_type.includes('2')) {
        if (companyAddressList.value.length == 0) {
            checkRes = false
            return
        }
        for (const item1 in productAddress) {
            const { key } = productAddress[item1]
            for (const item in companyAddressList.value) {
                // console.log(companyAddressList.value[item]);
                if (!companyAddressList.value[item][key] || typeof companyAddressList.value[item][key] == 'undefined') {
                    checkRes = false
                    break;
                }
            }
        }
    }
    return checkRes;
}
const checkContactAddress = () => {
    // check地址
    console.log(contact_address.value);
    let checkRes = true
    for (const item in contact_address.value) {
        if (!contact_address.value[item].countryKey ||
            !contact_address.value[item].province ||
            !contact_address.value[item].city ||
            !contact_address.value[item].address
            // ||
            // !contact_address.value[item].postcode
        ) {
            checkRes = false
            break;
        }
    }
    return checkRes;
}

const getFID =(item)=> {
    // 拼接 FBD-注册号-生产地址
    let res = ``;
    res = `FBD-${currendData.value.certificate_number}-${(item.country+ item.province + item.city + item.address).replace(/[^\u4e00-\u9fa5a-zA-Z0-9]/g, '')}`;
    return res;
}

const submit = async () => {
    /**提交信息 */
    // if (current_tab.value == 0) {
    let res = checkForm()
    if (!res) {
        showMessage('danger', getLangValue('base.requiredinformation'))
        return false
    }
    console.log(1);
    // 新增联系人地址
    let checkAddress = checkContactAddress()
    if (!checkAddress) {
        showMessage('danger', getLangValue('base.requiredinformation'))
        return false
    }
    console.log(2);
    let checkEmailRes = checkEmail()
    if (!checkEmailRes) {
        showMessage('danger', getLangValue('login.message10'))
        return false
    }
    // } else if (current_tab.value == 1) {
    let res2 = checkFrom1()
    if (!res2) {
        showMessage('danger', getLangValue('base.requiredinformation'))
        return false
    }
    console.log(3);
    // 
    let res1 = checkProductionAddress()
    if (!res1) {
        showMessage('danger', getLangValue('my.account', 'product_address_info'))
        return false
    }
    // console.log(4);
    // }
    let username = sessionStorage.getItem('set_menu_list') ? JSON.parse(sessionStorage.getItem('set_menu_list')).username : ''
    let params = {
        username: username,
        company_name: formData.value.company_name, //公司名称
        company_logo: formData.value.logo && formData.value.logo.length ? formData.value.logo.map(item => item.id)[0] : '', // logo
        company_type: formData.value.company_type.join(','), // 企业类型
        contact_first_name: formData.value.contact_first_name, //联系人姓
        contact_last_name: formData.value.contact_last_name, // 联系人名
        contact_name: formData.value.contact_first_name + formData.value.contact_last_name,
        contact_email: formData.value.contact_email, // 联系人邮箱
        landline_number: formData.value.landline_number, // 座机号码
        mobile_phone_number: formData.value.mobile_phone_number, // 手机号码
        // certification_company: formData.value.certification_company, // 是否第三方认证公司
        // testing_company: formData.value.testing_company, // 是否检测机构
        business_scope: formData.value.business_scope, //经营范围
        place_of_incorporation: formData.value.place_of_incorporation, //公司注册地
        certificate_number: formData.value.certificate_number, //证书编号
        company_qualification: formData.value.qualification_documents.map(item => item.id), //公司资质
        // Enterprise_registered_country: formData1[0].Enterprise_registered_country, // 企业注册地址国家
        landline_number_area: formData.value.landline_number_area, // 联系人座机 国家
        mobile_phone_number_area: formData.value.mobile_phone_number_area, // 联系人手机国家
        //新增字段
        company_qualification_validity_period: formData.value.company_qualification_validity_period,
        company_qualification_certification_body: formData.value.company_qualification_certification_body,
        company_website: formData.value.company_website,
        company_address: companyAddressList.value.map(item => {
            return {
                id: item.id,
                name: item.country, //简称
                country: item.countryKey, //国家
                province: item.province, //省
                province_code: item.province_code,
                city: item.city, //市
                address1: item.address, //详情地址1
                address2: '', //详情地址2
                address3: '', //详情地址3
                postcode: item.postcode, //邮编
            }
        }),
        contact_address: contact_address.value.map(item => {
            return {
                id: item.id,
                name: item.country, //简称
                country: item.countryKey, //国家
                province: item.province, //省
                city: item.city, //市
                address1: item.address, //详情地址1
                address2: '', //详情地址2
                address3: '', //详情地址3
                postcode: item.postcode, //邮编
            }
        }),
        update_email_url: '',
        website: '',
    }
    // console.log(params);
    // 获取url信息
    let url = window.location.href
    let arr = url.split('/#/')
    let website = arr[0]
    params.website = website
    params.update_email_url = `${website}/#/updateEmail`
    // console.log(params);
    let arr_permission = treeRef.value.getCheckedKeys()
    if (arr_permission.length == 0 && permission_tree.value.length) {
        showMessage('danger', getLangValue('business-user', "noUserPermissions"))
        return false
    }
    let xx = true
    if (xx) {
        let user_id = route.query.id
        const resp = await update_userInfo(user_id, params)
        if (resp.code == 0) {
            // 更新权限
            if (permission_tree.value.length) {
                let params1 = {
                    user_id: user_id,
                    permissions: arr_permission
                }
                const resp1 = await set_permission_user_v3(params1)
                if (resp1.code == 0) {
                    showMessage('success', getLangValue('my.account', "btn_submit_success"))
                    router.push({ path: '/business_information_management', query: { search_type: route.query.search_type || 0 } })
                } else {
                    showMessage('danger', resp1.message)
                }
            } else {
                showMessage('success', getLangValue('my.account', "btn_submit_success"))
                router.push({ path: '/business_information_management', query: { search_type: route.query.search_type || 0 } })
            }


        } else {
            showMessage('danger', resp.message)
        }
    }
}

const normalizeUrl =(url) => {
  if (!/^https?:\/\//i.test(url)) {
    return 'https://' + url;
  }
  return url;
}

const openWeb = (url) => {
    if(!url) return
    const safeUrl = normalizeUrl(url);
    window.open(safeUrl, '_blank')
}

const getCountryBykey = (countryK) => {
    if (countryK) {
        let arr = countryListData.filter(item => item.key === countryK)
        if (arr.length > 0) {
            return  i18n.global.locale == 'en' ? arr[0].en : arr[0].zh
        }
    }
    return ''
}
const getTree = (arr) => {
    let arr1 = arr.map(item => {
        let m = {
            id: item.slug,
            label: item.name,
            children: [],
        }
        if (item.permissions && item.permissions.length) {
            m.children = getTree(item.permissions)
        }
        return m
    })
    return arr1
}
const get_permission_tree_v3 = async () => {
    /**获取权限tree */
    const resp = await permission_tree_v3()
    if (resp.code == 0) {
        // console.log(resp.payload)
        permission_tree.value = getTree(resp.payload)
        // 获取当前用户权限
        let params = {
            user_id: route.query.id,
        }
        treeRef.value.setCheckedKeys([])
        const resp1 = await get_permission_user_v3(params)
        if (resp1.code == 0) {
            if (resp1.payload.length == 0) {
                //是未分配权限的
                tabList.value.pop()
            }
            treeRef.value.setCheckedKeys(resp1.payload)
        } else {
            showMessage('danger', resp1.message)
        }
    } else {
        showMessage('danger', resp.message)
    }
}
const changeProvince = (key) => {
    cityList.value[key] = []
    // console.log(companyAddressList.value[key].province);
    if (companyAddressList.value[key].province) {
        let arr = AreaJson.filter(item => item.name === companyAddressList.value[key].province)
        // console.log(arr);
        if (arr.length) {
            // 直辖市
            if (arr[0].city[0].name === companyAddressList.value[key].province) {
                // 获取区
                cityList.value[key] = arr[0].city[0].area.map(item => { return { name: item } })
                oldCityList.value[key] = [...cityList.value[key]]
            } else {
                cityList.value[key] = arr[0].city.map(item => { return { name: item.name } })
                oldCityList.value[key] = [...cityList.value[key]]
            }
            // console.log(cityList.value[key]);
        }
    }
}

const changeProvince1 = (key) => {
    cityList1.value[key] = []
    // console.log(companyAddressList.value[key].province);
    if (contact_address.value[key].province) {
        let arr = AreaJson.filter(item => item.name === contact_address.value[key].province)
        // console.log(arr);
        if (arr.length) {
            // 直辖市
            if (arr[0].city[0].name === contact_address.value[key].province) {
                // 获取区
                cityList1.value[key] = arr[0].city[0].area.map(item => { return { name: item } })
                oldCityList1.value[key] = [...cityList1.value[key]]
            } else {
                cityList1.value[key] = arr[0].city.map(item => { return { name: item.name } })
                oldCityList1.value[key] = [...cityList1.value[key]]
            }
            // console.log(cityList.value[key]);
        }
    }
}

/**
 * 文件上传部分
 */

const checkFile = (file) => {
    let name = /^device\//.test(file.name)
        ? file.name.substring(44)
        : file.name;
    let suffix = name.substring(name.lastIndexOf("."));
    // 判断是否属于指定的类型
    if (accept.indexOf(suffix) == -1) {
        showMessage("danger", getLangValue("upload.notCorrectType"));
        return false;
    }
    // 判断是否是同一个文件
    let arr = formData.value.qualification_documents.filter(item => item.filname == name)
    if (arr.length > 0) {
        showMessage("danger", getLangValue("upload.notSameFile"));
        return false;
    }
    return true;
}
const selectedFile = () => {
    let idStr = '#qualification_documents';
    let fileMaxSize = 1024 * 1024 * 50
    let dropzoneFile = document.querySelector(idStr).files[0];
    if (!dropzoneFile) return;
    if (dropzoneFile.size > fileMaxSize) {
        showMessage("danger", getLangValue("upload.limit"));
        document.getElementById("dropzoneFile").value = "";
        return;
    }
    if (!checkFile(dropzoneFile)) {
        document.getElementById("dropzoneFile").value = "";
        return;
    }
    // console.log(dropzoneFile);
    uploadFile(dropzoneFile)
        .then((res) => {
            res.data.payload.type = setType(res.data.payload.filename)
            formData.value.qualification_documents = [res.data.payload]
        })
        .catch((e) => {
            console.log(e);
        });

}
const drop = (e) => {
    let dropzoneFile = e.dataTransfer.files[0];
    if (!dropzoneFile) return;
}

const deleteFile = (url) => {
    // console.log(url);
    const index = formData.value.qualification_documents.findIndex(item => item.url == url)
    if (index > -1) {
        formData.value.qualification_documents.splice(index, 1);
        // console.log(formData.value.qualification_documents);
    }
}
const checkPermission = async () => {
    let params = {
        user_id: route.query.id,
    }
    const resp1 = await get_permission_user_v3(params)
    if (resp1.code == 0) {
        if (resp1.payload.length == 0) {
            //是未分配权限的
            tabList.value.pop()
        }
    }
}
const addAddress = () => {
    // 添加企业生产地址
    companyAddressList.value.push({
        id: '',
        country: '',
        countryKey: '',
        province: '',
        province_code: '',
        city: '',
        address: '',
        post: '',
    })
}

const handleChange = (file) => {
    /**文件上传部分 */
    // console.log(file);
    if (file.raw.type !== 'image/jpeg' && file.raw.type !== 'image/png' && file.raw.type !== 'image/jpg') {
        showMessage('danger', getLangValue("upload.notCorrectType"))
        return;
    }
    // 上传文件
    uploadFile(file.raw)
        .then((res) => {
            formData.value.logo = []
            formData.value.logo.push(res.data.payload);
            // console.log(formData.value.logo);
        })
        .catch((e) => {
            console.log(e);
        });
}

const getCompany_type_list = async () => {
    const reps = await company_type_list()
    if (reps.code == 0) {
        companyTypeList.value =  switch_company_type_list_to_language_config(reps.payload)
        getDetailByid()
    }
}

const getCompanyTypeName = (str) => {
    // 根据企业类型id获取名字
    let arr = str ? str.split(',') : []
    let name = []
    for (const item in arr) {
        let arr1 = companyTypeList.value.filter(item1 => item1.id == arr[item])
        if (arr1.length) {
            name.push(arr1[0].name)
        }
    }
    return name.join(',')
}

const getCompanyTypeNameById = (id) => {
    let arr1 = companyTypeList.value.filter(item1 => item1.id == id)
    if (arr1.length) {
        return arr1[0].name
    }
    return ''
}

/**
 * 文件上传部分
 */

const onlyUppercase = (index) => {
    // 只允许大写字母
    companyAddressList.value[index].province_code = companyAddressList.value[index].province_code.replace(/[^A-Z]/g, ''); // 非大写字母的字符会被移除
    console.log(companyAddressList.value[index].province_code);
}

const get_business_scope = (business_scope_list) => {
    // 获取信息
    let str = [];
    for (const item in business_scope_list) {
        const role_key = business_scope_list[item]
        let obj = main_business_areas_list.value.find(item => item.role_key === role_key)
        if (obj) {
            str.push(i18n.global.locale == 'en' ? obj.name_en : obj.name);
        }
    }
    return str.join('/');
}

const getCountryName = (country) => {
    // 获取国家名称
    let arr = countryList.value.filter(item => item.zh === country || item.en === country)
    if (arr.length > 0) {
        return i18n.global.locale == 'en' ? arr[0].en : arr[0].zh
    }
}

onMounted(() => {
    getCompany_type_list()
    getTemplateList()
    checkPermission();

})

// defineExpose({
//     currendData
// })
watch(currendData, (val) => {
    companyAddressList.value = val.company_address.map(item => {
        return {
            id: item.id,
            country: item.name,
            countryKey: item.country,
            province: item.province,
            province_code: item.province_code,
            city: item.city,
            address: item.address1,
            postcode: item.postcode,
        }
    })
    if (companyAddressList.value.length) {
        companyAddressList.value.forEach((item, key) => {
            if (item.countryKey == 'CN') {
                changeCountry(key)
                changeProvince(key)
            }
        })
    }
    // 联系人通讯信息
    contact_address.value = val.contact_address.map(item => {
        return {
            id: item.id,
            country: item.name,
            countryKey: item.country,
            province: item.province,
            city: item.city,
            address: item.address1,
            postcode: item.postcode,
        }
    })
    if (contact_address.value.length) {
        contact_address.value.forEach((item, key) => {
            if (item.countryKey == 'CN') {
                changeCountry1(key)
                changeProvince1(key)
            }
        })
    }
})
</script>
<template>
    <Layout>
        <PageHeader :title="PageHeaderT" :items="PageHeaderItems" />
        <div style="overflow-x: auto; overflow-y: hidden; height: calc(100vh - 140px);" class="my-detail">
            <div class="w-100 h-100 p-4 d-flex">
                <div class="me-4" style="width: 400px;">
                    <div class="card " style="min-height: 336px;">
                        <div
                            style="width: 160px; height: 160px; border-radius: 80px;border: 1px solid #E9EBEC; margin: 20px auto;">
                            <!-- <img :src="srcList1.length? srcList1[0].url: ''"> -->
                            <el-upload class="upload-demo" :auto-upload="false"
                                :class="route.query.type != 'edit' ? 'noEdit' : ''"
                                :on-change="(file, fileList) => handleChange(file, fileList)" :show-file-list="false">
                                <!-- <i class=" ri-add-circle-fill" style="color: #8591A2; font-size: 16px;"></i> -->
                                <div v-if="route.query.type != 'edit'">
                                    <img v-if="srcList1.length" :src="srcList1.length ? srcList1[0].url : ''"
                                        style="border-radius: 80px;width: 150px; height: 150px; object-fit: contain;">
                                    <Empty v-else :content="getLangValue('base.no_pictures')"></Empty>
                                </div>
                                <div v-else style="position: relative;height: 150px;width: 150px;">
                                    <img v-if="formData.logo && formData.logo.length"
                                        :src="formData.logo && formData.logo.length ? formData.logo[0].url : ''"
                                        style="border-radius: 80px;width: 150px; height: 150px; object-fit: contain;">
                                    <div v-else style="text-align: center;">
                                        <i class="display-4 text-muted ri-upload-cloud-2-fill"></i>
                                        <div style="color:#888a98">{{ getLangValue('upload.uploadedFile1Imag') }}</div>
                                    </div>
                                    <div class="d-flex justify-content-center align-items-center"
                                        style="position: absolute; right: 20px; bottom: 10px; width: 30px; height: 30px; border-radius: 15px; z-index: 111; background-color: #e7dddd">
                                        <i class="ri-camera-fill"> </i>
                                    </div>
                                </div>
                            </el-upload>
                        </div>
                        <div class="px-2 w-100 d-flex"
                            style=" color: #405189; font-size: 12px; font-weight: bold; min-width: 115px; margin: 0 auto; flex-wrap: wrap; justify-content: space-between;">
                            <template v-if="currendData.company_type">
                                <span class="px-2 my-1" style="background-color: #F3F6F9;border-radius: 6px;"
                                    v-for="(item, key) in currendData.company_type.split(',')" :key="key">{{
                                        getCompanyTypeNameById(item) }}</span>
                            </template>
                            <!-- <span class="mx-2" v-if="currendData.certification_company">{{
                               getLangValue('business-user', 'thirdCompany') }}</span>
                            <span class="mx-2" v-if="currendData.testing_company">{{
                               getLangValue('business-user', 'testingOrganization') }}</span> -->
                        </div>
                        <!-- <div v-if="currendData.certification_company || currendData.testing_company"
                            style="background-color: #F3F6F9; color: #405189; text-align: center; font-size: 12px; font-weight: bold; min-width: 115px; margin: 0 auto;"
                            class="px-2">
                            <span class="mx-2" v-if="currendData.certification_company">{{
                               getLangValue('business-user', 'thirdCompany') }}</span>
                            <span class="mx-2" v-if="currendData.testing_company">{{
                               getLangValue('business-user', 'testingOrganization') }}</span>
                        </div> -->
                        <div class="d-flex my-2">
                            <div style="flex: 1; padding-left: 60px;font-weight: bold;">{{
                               getLangValue('business-user', 'registre_time') }}:</div>
                            <div style="flex: 1;color: #9599AD;">{{ currendData.create_time ?
                                dateFormat1(currendData.create_time) : '' }}</div>
                        </div>
                        <div class="d-flex">
                            <div style="flex: 1; padding-left: 60px;font-weight: bold;">{{
                               getLangValue('business-user', 'lastLoginTime') }}:</div>
                            <div style="flex: 1;color: #9599AD;">{{ currendData.last_time ?
                                dateFormat1(currendData.last_time) : '' }}</div>
                        </div>
                    </div>
                    <div class="card mt-2 p-3" style="height: 274px;">
                        <div style="font-size: 16px; color: #495057;">{{getLangValue('business-user', 'passport')
                            }}</div>
                        <div style="width: 136px; height: 136px;margin: 0 auto;" class="my-3">
                            <img :src="qrcodeImgUrl">
                        </div>
                        <div style="text-align: center;font-size: 14px;">{{ currendData.place_of_incorporation +
                            currendData.certificate_number }}</div>
                    </div>
                </div>
                <div class="card py-2 px-1 my-scroll-bar" style="flex: 1; overflow-y: auto;">
                    <!-- tab -->
                    <div class="d-flex justify-content-between">
                        <ul class="nav nav-tabs nav-tabs-custom nav-success d-flex align-items-center " role="tablist"
                            style="border-bottom: 1px solid #E9EBEC; padding: 0;">
                            <li class="nav-item" v-for="(tab, i) in tabList" :key="i"
                                style="min-width: 115px; text-align: center;">
                                <a :class="[
                                    'nav-link',
                                    'All',
                                    'position-relative cursor',
                                    i == current_tab && 'active',
                                ]" @click="handlerToggleTab(i)"
                                    style="color: #405189; font-weight: 600; font-size: 13px;">
                                    {{ tab }}
                                </a>
                            </li>
                        </ul>
                        <div v-if="route.query.type == 'edit'">
                            <b-button class="btn btn-light" variant="success" @click="back"
                                style="min-width: 70px; height: 37px;">
                                {{ getLangValue('my.account', 'btn_back') }}
                            </b-button>
                            <b-button v-permit="'business-user.modify'" class="mx-2" variant="success" @click="submit"
                                style="min-width: 70px; height: 37px;background-color: #0AB39C;border-color: unset;">
                                {{ getLangValue('base.confirm') }}
                            </b-button>
                        </div>
                    </div>
                    <!-- <Transition name="myfade"> -->
                    <!-- 信息展示部分 -->
                    <!-- 账户信息 -->
                    <!-- <div> -->
                    <div class="account-info px-4" v-show="current_tab == 0">
                        <div class="d-flex" style="flex-wrap: wrap;">
                            <div v-for="(item, key) in accountInfo" :key="key" class="py-3"
                                style="flex: 1; min-width: 50%">
                                <div style="font-weight: bold;" class="my-2"><span class="text-danger"
                                        v-if="route.query.type == 'edit'">*</span>{{ item.name }}</div>
                                <div v-if="route.query.type != 'edit'">
                                    <div class="px-2" v-if="item.key != 'business_scope'">
                                        <span v-if="item.key == 'landline_number'">
                                            {{ getCountryName(currendData.landline_number_area) }}-
                                            {{ currendData.landline_number }}
                                        </span>
                                        <span v-else-if="item.key == 'mobile_phone_number'">
                                            {{ getCountryName(currendData.mobile_phone_number_area) }}-
                                            {{ currendData.mobile_phone_number }}
                                        </span>
                                        <span v-else-if="item.key == 'company_type'">
                                            {{ getCompanyTypeName(currendData.company_type) }}
                                        </span>
                                        <span v-else>{{ item.key.split(',').length
                                            > 1
                                            ?
                                            i18n.global.locale =='ch'? 
                                            currendData[item.key.split(',')[0]] +' '+ currendData[item.key.split(',')[1]] : currendData[item.key.split(',')[1]] +' '+ currendData[item.key.split(',')[0]]
                                            : currendData[item.key] }}
                                        </span>
                                    </div>
                                    <div class="px-2" v-else>{{ currendData['business_scope'] &&
                                        currendData['business_scope'].length > 0 ?
                                        get_business_scope(currendData['business_scope']):
                                        ''
                                        }}
                                    </div>
                                </div>
                                <div v-else class="px-2">
                                    <input v-if="item.type == 'text'"
                                        :class="[(isCheckForm && !formData[item.key]) && 'is-invalid']"
                                        v-model="formData[item.key]"
                                        :placeholder="getLangValue('my.account', 'form_companyName_placeholder')" class="form-control"
                                        style="display: inline; flex:1" />
                                    <el-select v-else-if="item.type == 'company_type'" collapse-tags
                                        collapse-tags-tooltip :max-collapse-tags="3"
                                        :class="[(isCheckForm && (formData.company_type == null || !formData.company_type.length)) && 'is-invalid']"
                                        v-model="formData[item.key]" filterable multiple
                                        :placeholder="getLangValue('my.account', 'form_Enterprisetype_placeholder')" size="large"
                                        style="width: 100%;" clearable>
                                        <el-option v-for="(item, key) in companyTypeList" :key="key" :label="item.name"
                                            :value="item.id" />
                                        <!-- <el-option label="生产商" value="生产商" />
                                        <el-option label="代理商" value="代理商" />
                                        <el-option label="其他组织" value="其他组织" /> -->
                                    </el-select>
                                    <div v-else-if="item.type == 'contact'" class="d-flex">
                                        <input :class="[(isCheckForm && !formData.contact_last_name) && 'is-invalid']"
                                            v-model="formData.contact_last_name"
                                            :placeholder="getLangValue('my.account', 'form_contacts_name')" class="form-control"
                                            style="display: inline; margin-right: 0.5rem;" />
                                        <input :class="[(isCheckForm && !formData.contact_first_name) && 'is-invalid']"
                                            v-model="formData.contact_first_name"
                                            :placeholder="getLangValue('my.account', 'form_contacts_xing')" class="form-control"
                                            style="display: inline;" />
                                    </div>
                                    <div class="input-group  d-flex" v-else-if="item.type == 'landline_number'">
                                        <div class="input-group-text p-0" style="width: 160px;height: 37.5px;"
                                            :class="[(isCheckForm && !formData.landline_number_area) && 'is-invalid1']">
                                            <el-select v-model="formData.landline_number_area" filterable placeholder=""
                                                size="large" style="width: 100%;height: 100%;" clearable
                                                :filter-method="filterCountry">
                                                <el-option v-for="item1 in countryList" :key="item1.key"
                                                    :label="i18n.global.locale == 'en' ? item1.en: item1.zh" :value="i18n.global.locale == 'en' ? item1.en: item1.zh">
                                                    <country-flag :country='item1.key' size='small' /> {{
                                                       i18n.global.locale == 'en' ? item1.en: item1.zh
                                                    }}
                                                </el-option>
                                            </el-select>
                                        </div>
                                        <input :class="[(isCheckForm && !formData[item.key]) && 'is-invalid']"
                                            v-model="formData[item.key]" :placeholder="getLangValue('my.account', 'form_phone')"
                                            class="form-control" style="display: inline; flex:1" />
                                    </div>
                                    <div class="input-group  d-flex" v-else-if="item.type == 'mobile_phone_number'">
                                        <div class="input-group-text p-0" style="width: 160px;height: 37.5px;"
                                            :class="[(isCheckForm && !formData.mobile_phone_number_area) && 'is-invalid1']">
                                            <el-select v-model="formData.mobile_phone_number_area" filterable
                                                placeholder="" size="large" style="width: 100%;height: 100%;" clearable
                                                :filter-method="filterCountry">
                                                <el-option v-for="item1 in countryList" :key="item1.key"
                                                    :label="i18n.global.locale == 'en' ? item1.en: item1.zh" :value="i18n.global.locale == 'en' ? item1.en: item1.zh">
                                                    <country-flag :country='item1.key' size='small' /> {{
                                                       i18n.global.locale == 'en' ? item1.en: item1.zh
                                                    }}
                                                </el-option>
                                            </el-select>
                                        </div>
                                        <input :class="[(isCheckForm && !formData[item.key]) && 'is-invalid']"
                                            v-model="formData[item.key]" :placeholder="getLangValue('my.account', 'form_phone_number')"
                                            class="form-control" style="display: inline; flex:1" />
                                    </div>
                                    <el-select v-else-if="item.type == 'business_scope'" collapse-tags
                                        collapse-tags-tooltip :max-collapse-tags="1"
                                        :class="[(isCheckForm && (formData.business_scope == null || !formData.business_scope.length)) && 'is-invalid']"
                                        v-model="formData.business_scope" filterable multiple
                                        :placeholder="getLangValue('my.account', 'form_main_business_areas_placeholder')" size="large"
                                        style="width: 100%;height: 37.5px;" clearable>
                                        <el-option v-for="(item, key) in main_business_areas_list" :key="key"
                                            :label="i18n.global.locale == 'en' ? item.name_en : item.name" :value="item.role_key" />
                                    </el-select>
                                </div>
                            </div>

                            <div class="py-3" style=" width: 100%"
                                v-if="route.query.type != 'edit' && route.query.search_type != 2">
                                <div style="font-weight: bold;" class="my-2">{{
                                   getLangValue('business-user', 'examine3') }}</div>
                                <div class="px-2">
                                    <textarea class="form-control" disabled id="exampleFormControlTextarea5" rows="3"
                                        v-model="currendData.examine_info"></textarea>
                                </div>
                            </div>
                            <!-- <div class="py-3" style=" width: 100%" v-else>
                                <div class="d-flex align-items-center justify-content-center">
                                    <b-button class="mx-2" variant="success" @click="back" style="width: 104px;">
                                        {{ getLangValue('my.account', 'btn_back') }}
                                    </b-button>
                                    <b-button class="mx-2" variant="success" @click="submit" style="width: 104px;">
                                        {{ getLangValue('base.confirm') }}
                                    </b-button>
                                </div>
                            </div> -->
                        </div>
                        <!-- 审核意见 -->
                    </div>
                    <!-- 企业信息 -->
                    <div class="account-info px-4" v-show="current_tab == 1">
                        <div class="d-flex" style="flex-wrap: wrap;">
                            <!-- <div v-for="(item, key) in companyInfo" :key="key">
                                <div class="py-3"
                                    v-if="(route.query.type != 'edit' && (item.key == 'file' || (item.key != 'file' && currendData[item.key]))) || (route.query.type == 'edit' && item.key != 'file' && currendData[item.key])">
                                    <div style="font-weight: bold;" class="my-2">
                                        <span class="text-danger" v-if="route.query.type == 'edit'">*</span>
                                        {{ item.name }}
                                    </div>
                                    <div v-if="route.query.type != 'edit'">
                                        <div class="px-2 d-flex align-items-center" v-if="item.key != 'file'">
                                            <country-flag :country='currendData[item.key]' size='small'
                                                v-if="item.key == 'place_of_incorporation'" />
                                            {{ item.key ==
                                                'place_of_incorporation' ? getCountryBykey(currendData[item.key]) :
                                                currendData[item.key] }}
                                        </div>
                                        <div class="px-2 cursor-pointer" v-else @click="viewFile(item.index)">
                                            <a style="color: #6691E7; text-decoration: underline !important;">
                                                {{
                                                   getLangValue('business-user', 'viewfile') }}</a>
                                        </div>
                                    </div>
                                    <div v-else class="px-2">
                                        <el-select v-if="item.key == 'place_of_incorporation'"
                                            :class="[(isCheckForm && !formData.place_of_incorporation) && 'is-invalid']"
                                            @change="changeAddressCountry" v-model="formData.place_of_incorporation"
                                            filterable placeholder=" " size="large" style="width: 100%;height: 37.5px;"
                                            clearable :filter-method="filterCountry">
                                            <template #prefix>
                                                <country-flag :country='formData.place_of_incorporation' size='small' />
                                            </template>
<el-option v-for="item1 in countryList" :key="item1.key" :label="item1.zh" :value="item1.key">
    <country-flag :country='item1.key' size='small' /> {{ item1.zh
    }}
</el-option>
</el-select>
<input v-else-if="item.type == 'text'" :class="[(isCheckForm && !formData[item.key]) && 'is-invalid']"
    v-model="formData[item.key]" :placeholder="getLangValue('my.account', 'form_Certificate_No')" class="form-control"
    style="display: inline; flex:1" />
</div>
</div>
</div> -->
                            <div style="flex: 1; min-width: 50%">
                                <div class="py-3">
                                    <div style="font-weight: bold;" class="my-2">
                                        <span class="text-danger" v-if="route.query.type == 'edit'">*</span>
                                        {{ getLangValue('my.account', "form_Enterprise_registered_address") }}
                                    </div>
                                    <div v-if="route.query.type != 'edit'">
                                        <div class="px-2 d-flex align-items-center">
                                            <country-flag :country='currendData["place_of_incorporation"]'
                                                size='small' />
                                            {{ getCountryBykey(currendData['place_of_incorporation']) }}
                                        </div>
                                    </div>
                                    <div v-else class="px-2">
                                        <el-select
                                            :class="[(isCheckForm && !formData.place_of_incorporation) && 'is-invalid']"
                                            @change="changeAddressCountry" v-model="formData.place_of_incorporation"
                                            filterable placeholder=" " size="large" style="width: 100%;height: 37.5px;"
                                            clearable :filter-method="filterCountry">
                                            <template #prefix>
                                                <country-flag :country='formData.place_of_incorporation' size='small' />
                                            </template>
                                            <el-option v-for="item1 in countryList" :key="i18n.global.locale == 'en' ? item1.en: item1.zh" :label="i18n.global.locale == 'en' ? item1.en: item1.zh"
                                                :value="item1.key">
                                                <country-flag :country='item1.key' size='small' /> {{ i18n.global.locale == 'en' ? item1.en: item1.zh
                                                }}
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>
                            </div>
                            <div style="flex: 1; min-width: 50%">
                                <div class="py-3">
                                    <div style="font-weight: bold;" class="my-2">
                                        <span class="text-danger" v-if="route.query.type == 'edit'">*</span>
                                        {{ getLangValue('my.account', "form_Certificate_No") }}
                                    </div>
                                    <div v-if="route.query.type != 'edit'">
                                        <div class="px-2 d-flex align-items-center">
                                            {{ currendData.certificate_number }}
                                        </div>
                                    </div>
                                    <div v-else class="px-2">
                                        <input :class="[(isCheckForm && !formData.certificate_number) && 'is-invalid']"
                                            v-model="formData.certificate_number"
                                            :placeholder="getLangValue('my.account', 'form_Certificate_No')" class="form-control"
                                            style="display: inline; flex:1" />
                                    </div>
                                </div>
                            </div>
                            <div style="flex: 1; min-width: 50%"
                                v-if="formData.company_type && formData.company_type.includes('7')">
                                <div class="py-3">
                                    <div style="font-weight: bold;" class="my-2">
                                        <span class="text-danger"
                                            v-if="route.query.type == 'edit' && formData.company_type.includes('7')">*</span>
                                        {{ getLangValue('my.account', "form_qualification_certification") }}
                                    </div>
                                    <div v-if="route.query.type != 'edit'">
                                        <div class="px-2 d-flex align-items-center">
                                            {{ currendData.company_qualification_validity_period }}
                                        </div>
                                    </div>
                                    <div v-else class="px-2">
                                        <!-- <input
                                            :class="[(isCheckForm && !formData.company_qualification_validity_period) && 'is-invalid']"
                                            v-model="formData.company_qualification_validity_period"
                                            :placeholder="getLangValue('my.account', 'form_qualification_certification')"
                                            class="form-control" style="display: inline; flex:1" /> -->
                                        <!-- <flat-pickr v-model="formData.company_qualification_validity_period"
                                            style="background-color: unset;display: inline;"
                                            :class="[(isCheckForm && formData.company_type.includes('7') && !formData.company_qualification_validity_period) && 'is-invalid']"
                                            :placeholder="getLangValue('my.account', 'form_qualification_certification')"
                                            :config="{ enableTime: false, dateFormat: 'Y-m-d' }" class="form-control">
                                        </flat-pickr> -->
                                        <el-date-picker :shortcuts="shortcuts" style="height: 37.5px; width: 100%;"
                                            v-model="formData.company_qualification_validity_period"
                                            :placeholder="getLangValue('my.account', 'form_qualification_certification')" size="large"
                                            value-format="YYYY-MM-DD"
                                            :class="[(isCheckForm && formData.company_type.includes('7') && !formData.company_qualification_validity_period) && 'is-invalid']" />
                                    </div>
                                </div>
                            </div>
                            <div style="flex: 1; min-width: 50%"
                                v-if="formData.company_type && formData.company_type.includes('7')">
                                <div class="py-3">
                                    <div style="font-weight: bold;" class="my-2">
                                        <span class="text-danger"
                                            v-if="route.query.type == 'edit' && formData.company_type.includes('7')">*</span>
                                        {{ getLangValue('my.account', "form_qualification_certification1") }}
                                    </div>
                                    <div v-if="route.query.type != 'edit'">
                                        <div class="px-2 d-flex align-items-center">
                                            {{ currendData.company_qualification_certification_body }}
                                        </div>
                                    </div>
                                    <div v-else class="px-2">
                                        <input
                                            :class="[(isCheckForm && formData.company_type.includes('7') && !formData.company_qualification_certification_body) && 'is-invalid']"
                                            v-model="formData.company_qualification_certification_body"
                                            :placeholder="getLangValue('my.account', 'form_qualification_certification1')"
                                            class="form-control" style="display: inline; flex:1" />
                                    </div>
                                </div>
                            </div>
                            <div style="flex: 1; min-width: 50%">
                                <div class="py-3">
                                    <div style="font-weight: bold;" class="my-2">
                                        <span class="text-danger" v-if="route.query.type == 'edit'"></span>
                                        {{ getLangValue('my.account', "form_company_link") }}
                                    </div>
                                    <div v-if="route.query.type != 'edit'">
                                        <div class="px-2 d-flex align-items-center" style="word-break: break-all;">
                                            <a @click="openWeb(currendData.company_website)"
                                                style="text-decoration: underline !important;color: #6691E7;">
                                                {{ currendData.company_website }}
                                            </a>
                                        </div>
                                    </div>
                                    <div v-else class="px-2">
                                        <input v-model="formData.company_website"
                                            :placeholder="getLangValue('my.account', 'form_company_link')" class="form-control"
                                            style="display: inline; flex:1" />
                                    </div>
                                </div>
                            </div>

                            <div style="flex: 1; min-width: 50%" v-if="route.query.type != 'edit'">
                                <div class="py-3">
                                    <div style="font-weight: bold;" class="my-2">
                                        {{ getLangValue('my.account', "form_qualification_documents") }}
                                    </div>
                                    <div>
                                        <div class="px-2 cursor-pointer" @click="viewFile(0)">
                                            <a style="color: #6691E7; text-decoration: underline !important;">
                                                {{
                                                   getLangValue('business-user', 'viewfile') }}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style="flex: 1; min-width: 50%" v-if="route.query.type != 'edit'">
                                <div class="py-3">
                                    <div style="font-weight: bold;" class="my-2">
                                        <!-- <span class="text-danger" v-if="route.query.type == 'edit'">*</span> -->
                                        {{ getLangValue('my.account', "logo") }}
                                    </div>
                                    <div>
                                        <div class="px-2 cursor-pointer" @click="viewFile(1)">
                                            <a style="color: #6691E7; text-decoration: underline !important;">
                                                {{
                                                   getLangValue('business-user', 'viewfile') }}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 企业通讯地址信息 -->
                            <div class="d-flex" style="width: 100%;flex-wrap: wrap;border-top:1px dashed #0ab39c"
                                v-for="(item, key) in contact_address" :key="key">
                                <div class="my-2" style="width: 100%;flex-wrap: wrap; font-weight: bold;">{{
                                    getLangValue('my.account', 'contact_address') }}</div>
                                <div v-if="route.query.type != 'edit'" style="width: 100%;flex-wrap: wrap"
                                    class="d-flex ">
                                    <div v-for="(item1, key1) in contactAddress" :key="key1" class="py-2"
                                        style="flex: 1; min-width: 50%">
                                        <div style="font-weight: bold;" class="my-2">{{ item1.name }}</div>
                                        <div class="px-2 d-flex align-items-center">
                                            <country-flag :country='item["countryKey"]' size='small'
                                                v-if="item1.key == 'country'" />
                                            <span v-if="item1.key == 'country'">{{ getCountryName(item[item1.key]) }}</span>
                                            <span v-else>{{ item[item1.key] }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="d-flex" style="width: 100%; flex-wrap: wrap;">
                                    <div class="py-2 px-2" style="flex: 1; min-width: 50%">
                                        <div style="font-weight: bold;" class="my-2"> <span class="text-danger"
                                                v-if="route.query.type == 'edit'">*</span><span>{{
                                                    getLangValue('my.account', 'form_country') }}</span></div>
                                        <div class="input-group  d-flex">
                                            <div class="input-group-text p-0" style="width: 160px;height: 37.5px;"
                                                :class="[(isCheckForm && !item.country) && 'is-invalid1']">
                                                <el-select v-model="item.country" filterable placeholder=""
                                                    @change='changeCountry1(key)' size="large"
                                                    style="width: 100%; height: 100%;" clearable
                                                    :filter-method="filterCountry">
                                                    <template #prefix>
                                                        <!-- 将前置插槽数据设置为label的值 -->
                                                        <country-flag :country='item.countryKey' size='small' />
                                                    </template>
                                                    <el-option v-for="item1 in countryList" :key="item1.key"
                                                        :label="i18n.global.locale == 'en' ? item1.en: item1.zh" :value="i18n.global.locale == 'en' ? item1.en: item1.zh">
                                                        <country-flag :country='item1.key' size='small' /> {{
                                                            i18n.global.locale == 'en' ? item1.en: item1.zh
                                                        }}
                                                    </el-option>
                                                </el-select>
                                            </div>
                                            <input disabled clearable class="form-control flex-1"
                                                v-model="item.countryKey"
                                                :class="[(isCheckForm && !item.countryKey) && 'is-invalid']" required />
                                        </div>
                                    </div>
                                    <div class="py-2 px-2" style="flex: 1; min-width: 50%">
                                        <div style="font-weight: bold;" class="my-2"><span class="text-danger"
                                                v-if="route.query.type == 'edit'">*</span>
                                            <span>{{
                                                getLangValue('my.account', 'form_province') }}</span>
                                        </div>
                                        <el-select v-if="item.countryKey == 'CN'"
                                            :class="[(isCheckForm && !item.province) && 'is-invalid']"
                                            @change="changeProvince1(key)" v-model="item.province" filterable
                                            :filter-method="(query) => filterProvince(query, key)" placeholder=""
                                            size="large" style="width: 100%;height: 37.5px;" clearable>
                                            <el-option v-for="item1 in provinceList1[key]" :key="item1.name"
                                                :label="item1.name" :value="item1.name">
                                            </el-option>
                                        </el-select>
                                        <input v-else :class="[(isCheckForm && !item.province) && 'is-invalid']"
                                            v-model="item.province" class="form-control"
                                            style="display: inline; flex:1" />
                                    </div>
                                    <div class="py-2 px-2" style="flex: 1; min-width: 50%">
                                        <div style="font-weight: bold;" class="my-2"><span class="text-danger"
                                                v-if="route.query.type == 'edit'">*</span><span>{{
                                                    getLangValue('my.account', 'form_City')
                                                }}</span></div>
                                        <el-select v-if="item.countryKey == 'CN'"
                                            :class="[(isCheckForm && !item.city) && 'is-invalid']" v-model="item.city"
                                            filterable placeholder="" size="large" style="width: 100%;height: 37.5px;"
                                            :filter-method="(query) => filterCity(query, key)" clearable>
                                            <el-option v-for="item1 in cityList1[key]" :key="item1.name"
                                                :label="item1.name" :value="item1.name">
                                            </el-option>
                                        </el-select>
                                        <input v-else :class="[(isCheckForm && !item.city) && 'is-invalid']"
                                            v-model="item.city" class="form-control" style="display: inline; flex:1" />
                                    </div>
                                    <div class="py-2 px-2" style="flex: 1; min-width: 50%">
                                        <div style="font-weight: bold;" class="my-2"><span class="text-danger"
                                                v-if="route.query.type == 'edit'">*</span><span>{{
                                                    getLangValue('my.account', 'form_address')
                                                }}</span></div>
                                        <input :class="[(isCheckForm && !item.address) && 'is-invalid']"
                                            v-model="item.address" class="form-control"
                                            style="display: inline; flex:1" />
                                    </div>
                                    <div class="py-2 px-2" style="flex: 1; min-width: 50%">
                                        <div style="font-weight: bold;" class="my-2"><span class="text-danger"
                                                v-if="route.query.type == 'edit'">*</span>{{
                                                    getLangValue('my.account', 'form_post')
                                                }}
                                        </div>
                                        <input :class="[(isCheckForm && !item.postcode) && 'is-invalid']"
                                            v-model="item.postcode" class="form-control"
                                            style="display: inline; flex:1" />
                                    </div>
                                </div>
                            </div>
                            <!-- 生产地址信息  制造商 供应商才显示 -->
                            <template
                                v-if="formData.company_type && (formData.company_type.includes('1') || formData.company_type.includes('2'))">
                                <div class="d-flex" style="width: 100%;flex-wrap: wrap;border-top:1px dashed #0ab39c"
                                    v-for="(item, key) in companyAddressList" :key="key">
                                    <div class="my-2" style="width: 100%;flex-wrap: wrap; font-weight: bold;">{{
                                        getLangValue('my.account', 'enterprise_production_address') }}{{ key + 1 }}
                                        <div class="my-1" v-if="route.query.type != 'edit'"><span style="color:#0ab39c">{{getLangValue('product-management', "fid")}}</span> : <span style="font-weight: 400;">{{getFID(item)}}</span></div>
                                    </div>
                                    <div v-if="route.query.type != 'edit'" style="width: 100%;flex-wrap: wrap"
                                        class="d-flex ">
                                        <div v-for="(item1, key1) in productAddress" :key="key1" class="py-2"
                                            style="flex: 1; min-width: 50%">
                                            <div style="font-weight: bold;" class="my-2">{{ item1.name }}</div>
                                            <div class="px-2 d-flex align-items-center">
                                                <country-flag :country='item["countryKey"]' size='small'
                                                    v-if="item1.key == 'country'" />
                                                <span v-if="item1.key == 'country'">{{ getCountryName(item[item1.key]) }}</span>
                                                <span v-else>{{ item[item1.key] }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="d-flex" style="width: 100%; flex-wrap: wrap;">
                                        <div class="py-2 px-2" style="flex: 1; min-width: 50%">
                                            <div style="font-weight: bold;" class="my-2"> <span class="text-danger"
                                                    v-if="route.query.type == 'edit' && (formData.company_type.includes('1') || formData.company_type.includes('2'))">*</span><span>{{
                                                        getLangValue('my.account', 'form_country') }}</span></div>
                                            <div class="input-group  d-flex">
                                                <div class="input-group-text p-0" style="width: 160px;height: 37.5px;"
                                                    :class="[(isCheckForm && (formData.company_type.includes('1') || formData.company_type.includes('2')) && !item.country) && 'is-invalid1']">
                                                    <el-select v-model="item.country" filterable placeholder=""
                                                        @change='changeCountry(key)' size="large"
                                                        style="width: 100%; height: 100%;" clearable
                                                        :filter-method="filterCountry">
                                                        <template #prefix>
                                                            <!-- 将前置插槽数据设置为label的值 -->
                                                            <country-flag :country='item.countryKey' size='small' />
                                                        </template>
                                                        <el-option v-for="item1 in countryList" :key="item1.key"
                                                            :label="i18n.global.locale == 'en' ? item1.en: item1.zh" :value="i18n.global.locale == 'en' ? item1.en: item1.zh">
                                                            <country-flag :country='item1.key' size='small' /> {{
                                                               i18n.global.locale == 'en' ? item1.en: item1.zh
                                                            }}
                                                        </el-option>
                                                    </el-select>
                                                </div>
                                                <input disabled clearable class="form-control flex-1"
                                                    v-model="item.countryKey"
                                                    :class="[(isCheckForm && (formData.company_type.includes('1') || formData.company_type.includes('2')) && !item.countryKey) && 'is-invalid']"
                                                    required />
                                            </div>
                                        </div>
                                        <div class="py-2 px-2" style="flex: 1; min-width: 50%">
                                            <div style="font-weight: bold;" class="my-2"><span class="text-danger"
                                                    v-if="route.query.type == 'edit' && (formData.company_type.includes('1') || formData.company_type.includes('2'))">*</span>
                                                <span>{{
                                                    getLangValue('my.account', 'form_province') }}</span>
                                            </div>
                                            <el-select v-if="item.countryKey == 'CN'"
                                                :class="[(isCheckForm && (formData.company_type.includes('1') || formData.company_type.includes('2')) && !item.province) && 'is-invalid']"
                                                @change="changeProvince(key)" v-model="item.province" filterable
                                                :filter-method="(query) => filterProvince(query, key)" placeholder=""
                                                size="large" style="width: 100%;height: 37.5px;" clearable>
                                                <el-option v-for="item1 in provinceList[key]" :key="item1.name"
                                                    :label="item1.name" :value="item1.name">
                                                </el-option>
                                            </el-select>
                                            <input v-else
                                                :class="[(isCheckForm && (formData.company_type.includes('1') || formData.company_type.includes('2')) && !item.province) && 'is-invalid']"
                                                v-model="item.province" class="form-control"
                                                style="display: inline; flex:1" />
                                        </div>
                                        <div class="py-2 px-2" style="flex: 1; min-width: 50%">
                                            <div style="font-weight: bold;" class="my-2"><span class="text-danger"
                                                    v-if="route.query.type == 'edit' && (formData.company_type.includes('1') || formData.company_type.includes('2'))">*</span>
                                                <span>{{
                                                    getLangValue('my.account', 'form_province_code') }}</span>
                                            </div>
                                            <input
                                                :class="[(isCheckForm && (formData.company_type.includes('1') || formData.company_type.includes('2')) && !item.province_code) && 'is-invalid']"
                                                v-model="item.province_code" class="form-control"
                                                @blur="onlyUppercase(key)"
                                                :placeholder="getLangValue('my.account', 'form_province_code_placeholder')"
                                                style="display: inline; flex:1" />
                                        </div>
                                        <div class="py-2 px-2" style="flex: 1; min-width: 50%">
                                            <div style="font-weight: bold;" class="my-2"><span class="text-danger"
                                                    v-if="route.query.type == 'edit' && (formData.company_type.includes('1') || formData.company_type.includes('2'))">*</span><span>{{
                                                        getLangValue('my.account', 'form_City')
                                                    }}</span></div>
                                            <el-select v-if="item.countryKey == 'CN'"
                                                :class="[(isCheckForm && (formData.company_type.includes('1') || formData.company_type.includes('2')) && !item.city) && 'is-invalid']"
                                                v-model="item.city" filterable placeholder="" size="large"
                                                style="width: 100%;height: 37.5px;"
                                                :filter-method="(query) => filterCity(query, key)" clearable>
                                                <el-option v-for="item1 in cityList[key]" :key="item1.name"
                                                    :label="item1.name" :value="item1.name">
                                                </el-option>
                                            </el-select>
                                            <input v-else
                                                :class="[(isCheckForm && (formData.company_type.includes('1') || formData.company_type.includes('2')) && !item.city) && 'is-invalid']"
                                                v-model="item.city" class="form-control"
                                                style="display: inline; flex:1" />
                                        </div>
                                        <div class="py-2 px-2" style="flex: 1; min-width: 50%">
                                            <div style="font-weight: bold;" class="my-2"><span class="text-danger"
                                                    v-if="route.query.type == 'edit' && (formData.company_type.includes('1') || formData.company_type.includes('2'))">*</span><span>{{
                                                        getLangValue('my.account', 'form_address')
                                                    }}</span></div>
                                            <input
                                                :class="[(isCheckForm && (formData.company_type.includes('1') || formData.company_type.includes('2')) && !item.address) && 'is-invalid']"
                                                v-model="item.address" class="form-control"
                                                style="display: inline; flex:1" />
                                        </div>
                                        <div class="py-2 px-2" style="flex: 1; min-width: 50%">
                                            <div style="font-weight: bold;" class="my-2"><span class="text-danger"
                                                    v-if="route.query.type == 'edit' && (formData.company_type.includes('1') || formData.company_type.includes('2'))">*</span>{{
                                                        getLangValue('my.account', 'form_post')
                                                    }}
                                            </div>
                                            <input
                                                :class="[(isCheckForm && (formData.company_type.includes('1') || formData.company_type.includes('2')) && !item.postcode) && 'is-invalid']"
                                                v-model="item.postcode" class="form-control"
                                                style="display: inline; flex:1" />
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex align-items-center"
                                    v-if="route.query.type == 'edit' && (formData.company_type.includes('1') || formData.company_type.includes('2'))">
                                    <div @click="addAddress"
                                        class="d-flex align-items-center justify-content-center cursor-pointer px-1"
                                        style="min-width: 104px; 
                                border:1px dashed #6691E7;
                                background-color: unset;
                                height: 24px;
                                color: #6691E7;
                                font-size: 12px;
                                border-radius: 2px;
                                text-align: center;
                            ">
                                        <i class="ri-add-fill"></i>{{ getLangValue('my.account', 'btn_add_production_address') }}
                                    </div>
                                </div>
                            </template>
                            <div class="py-3" style=" width: 100%"
                                v-if="route.query.type != 'edit' && route.query.search_type != 2">
                                <div style="font-weight: bold;" class="my-2">{{
                                   getLangValue('business-user', 'examine3') }}</div>
                                <div class="px-2">
                                    <textarea class="form-control" disabled id="exampleFormControlTextarea5" rows="3"
                                        v-model="currendData.examine_info"></textarea>
                                </div>
                            </div>
                            <!-- 资质文件 -->
                            <div class="py-3 px-2" style=" width: 100%" v-if="route.query.type == 'edit'">
                                <div style="font-weight: bold;" class="my-2">
                                    <span class="text-danger">*</span>{{
                                        getLangValue('my.account', 'form_qualification_documents') }}
                                </div>
                                <DropZone ipt-id="qualification_documents" :accept="accept" @drop.prevent="drop"
                                    @change.prevent="selectedFile" style="min-height: 220px" limit="50M"
                                    :info="getLangValue('upload.fileTypeLimit1')"
                                    :class="[(isCheckForm && formData.qualification_documents.length == 0) && 'is-invalid']" />
                                <div class="file-view m-2" v-for="(image, kk) in formData.qualification_documents"
                                    :key="kk"
                                    style="display: inline-block; text-align: center; border: 1px solid #E9EBEC;  border-radius: 4px; position: relative; width: 150px; height: 100px;">
                                    <i v-if="image.type == 'file'" class="ri-file-text-line"
                                        style="font-size: 60px;color:#0AB39C"></i>
                                    <img v-else :src="image.url" alt="" @click="handleImgPreview(image.url)"
                                        class="cursor-pointer" />
                                    <!-- 文件操作按钮 -->
                                    <fileActionCom :image="image" :showDelete="true" @delete="deleteFile" />
                                </div>
                            </div>
                            <!-- <div class="py-3" style=" width: 100%" v-if="route.query.type == 'edit'">
                                <div class="d-flex align-items-center justify-content-center">
                                    <b-button class="mx-2" variant="success" @click="back" style="width: 104px;">
                                        {{ getLangValue('my.account', 'btn_back') }}
                                    </b-button>
                                    <b-button class="mx-2" variant="success" @click="submit" style="width: 104px;">
                                        {{ getLangValue('base.confirm') }}
                                    </b-button>
                                </div>
                            </div> -->
                        </div>
                        <!-- 审核意见 -->
                    </div>
                    <!-- 权限信息 -->
                    <div class="account-info px-4" v-show="current_tab == 2">
                        <div class="d-flex  flex-column" style="margin:  0 auto;">
                            <ul class="nav nav-tabs nav-tabs-custom nav-success d-flex align-items-center "
                                role="tablist" style="border-bottom: 1px dashed #E9EBEC; padding: 0;">
                                <li class="nav-item" v-for="(tab, i) in tabList1" :key="i"
                                    style="min-width: 115px; text-align: center;">
                                    <a :class="[
                                        'nav-link',
                                        'All',
                                        'position-relative cursor',
                                        i == current_tab1 && 'active11',
                                    ]" @click="handlerToggleTab1(i)"
                                        style="color: #0AB39C; font-weight: 600; font-size: 13px;">
                                        <i :class="tab.icon" class="mx-2"></i>{{ tab.name }}
                                    </a>

                                </li>
                            </ul>
                            <!-- 权限树 -->
                            <div class="my-2" :class="route.query.type == 'edit' ? '' : 'noEdit'">
                                <el-tree ref="treeRef" style="max-width: 600px" :data="permission_tree" show-checkbox
                                    node-key="id" default-expand-all />
                            </div>
                        </div>
                    </div>
                    <!-- </div> -->
                    <!-- </Transition> -->
                </div>
            </div>
        </div>
        <PreviewImg v-model:showPreviewImg="showPreviewImg" :srcList="srcList" v-if="showPreviewImg"></PreviewImg>
        <PreviewImg v-model:showPreviewImg="showPreviewImg1" :srcList="srcList1" v-if="showPreviewImg1"></PreviewImg>
    </Layout>
</template>

<style scoped lang="scss">
/* .active {
    background-color: #0AB39C !important;
} */
.my-detail {
    .nav-success.nav-tabs-custom .nav-link.active::after {
        background-color: #405189;
    }

    .nav-success.nav-tabs-custom .nav-link.active11::after {
        background-color: #0AB39c !important;
        border-bottom: 1px solid #0AB39c;
    }

    :deep(label) {
        margin-bottom: 0px !important;
    }

    .myC-3 {
        padding: 0.5rem 0 0.5rem 0;
    }

    .is-invalid {
        border: 1px solid #f06548;
        border-radius: 4px;
    }

    :deep(.is-invalid .el-input__wrapper) {
        border: 1px solid #f06548 !important;
    }

    .mx-3 {
        padding-left: 20px !important;
    }

    .is-invalid1 {
        border: 1px solid #f06548;
        border-right: unset !important;
    }

    :deep(.input-group-text .el-select__wrapper) {
        box-shadow: unset !important;
    }

    :deep(.el-select--large .el-select__wrapper) {
        min-height: unset;
        height: 100%;
    }

    .upload-demo {
        width: 160px;
        height: 160px;

        :deep(.el-upload--text) {
            height: 100%;
            width: 100%;
        }
    }

    .noEdit {
        pointer-events: none;
    }

    :deep(.el-select__placeholder.is-transparent) {
        font-size: 0.8125rem;
        color: #878a99 !important;
    }

    :deep(.el-select__selected-item.el-select__placeholder) {
        font-size: 0.8125rem;
        color: #212529;
    }
}
</style>